var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.webshopSources.length > 2)?_c('KSelect',_vm._g(_vm._b({attrs:{"items":_vm.webshopSources,"item-text":"name","item-value":"code","return-object":false}},'KSelect',_vm.$attrs,false),_vm.$listeners)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }